import {BackgroundWave} from "@commons/uinew/domaincomponent/svg";

export let GreyBottomBackgroundWave1 = ({blok, zIndex, background}) => {
    return <BackgroundWave height={blok.Height} zIndex={zIndex} background={background}/>
}